import { VendorHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/vendor-handler';
import {
  IOAuthDetails,
  IVendorConnectConfirmation,
  IVendorConnectInitRequest,
  IVendorConnectInitResponse
} from '@portal/app/dashboard/integrations/models/vendor/VendorIntegrationModels';
import { IVendorInitiateRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorInitiateRequest';
import {
  callbackDomain,
  VendorIdSource
} from '@portal/app/dashboard/integrations/shared/constants';
import { IVendorConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorConfigurationRequest';
import { IVendorOAuthConfirmationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorOAuthConfirmationRequest';
import { StorageService } from '@portal/app/shared/services/storage.service';
import { IVendorReConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorReConfigurationRequest';
import { WindowService } from '@portal/app/shared/services/window.service';

export class ShopifyHandler implements VendorHandler {
  constructor(
    private storageService: StorageService,
    private windowService: WindowService
  ) {}

  prepareRequestObjectToInitiateVendor(
    vendorDetails: IVendorConnectInitRequest
  ): IVendorInitiateRequest {
    return {
      queryParams: {
        shop: `${vendorDetails.shop}.myshopify.com`,
        callbackDomain: callbackDomain()
      },
      pathParams: { vendorId: VendorIdSource.shopify }
    };
  }

  handleVendorInitiateResponse(data: IVendorConnectInitResponse): void {
    localStorage.setItem(
      'callBackParams',
      JSON.stringify(
        (data.vendorCredentialsDetails as IOAuthDetails).callbackParameters
      )
    );
    this.windowService.navigateToHref(
      (data.vendorCredentialsDetails as IOAuthDetails).redirectURL
    );
  }

  confirmVendor(data: IVendorConnectConfirmation): void {
    const jsonData = data.accountDetails
      ? JSON.stringify(data.accountDetails.vendorAccounts)
      : '';
    this.storageService.setIntegrationAccountDetails(
      VendorIdSource.shopify,
      jsonData
    );
  }

  prepareRequestObjectToConfigureVendor(
    accounts: {
      accountName: string;
      accountId: string;
      managerId?: string;
      disabled: boolean;
    }[]
  ): IVendorConfigurationRequest {
    /* eslint-disable no-console */
    console.log(`Shopify handler: ${accounts}`);
    return {
      vendorId: VendorIdSource.shopify,
      vendorData: [
        {
          shopName: `${localStorage.getItem('shop')}`,
          baseUrl: 'https://' + `${localStorage.getItem('shop')}`
        }
      ]
    };
  }

  prepareRequestToConfirmVendor(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    confirmationData?: Record<string, unknown>
  ): IVendorOAuthConfirmationRequest {
    return {
      code: `${localStorage.getItem('code')}`,
      state: `${localStorage.getItem('state')}`,
      shop: `${localStorage.getItem('shop')}`,
      hmac: `${localStorage.getItem('hmac')}`,
      callbackDomain: callbackDomain()
    };
  }

  prepareRequestObjectToReConfigureVendor(
    accounts: {
      accountName: string;
      accountId: string;
      managerId?: string | undefined;
      disabled: boolean;
    }[],
    dsInstanceIds: number[]
  ): IVendorReConfigurationRequest {
    return {
      vendorId: VendorIdSource.shopify,
      vendorData: [
        {
          shopName: `${localStorage.getItem('shop')}`,
          baseUrl: 'https://' + `${localStorage.getItem('shop')}`
        }
      ],
      dsInstanceIds
    };
  }
}
